// Imports: local files.
import {
  GET_USERS_START,
  GET_USERS_SUCCESS,
  GET_USERS_FAILED,
  GET_USERS_RESET,
  GET_USER_START,
  GET_USER_SUCCESS,
  GET_USER_FAILED,
  GET_USER_RESET,
  BLOCK_USER_START,
  BLOCK_USER_SUCCESS,
  BLOCK_USER_FAILED,
  BLOCK_USER_RESET,
} from '../actions';

const initialLoadingState = {
  loading: false,
  success: false,
  data: null,
  error: false,
  errorMessage: null,
};
const initialState = {
  getAll: initialLoadingState,
  getOne: initialLoadingState,
  blockOne: initialLoadingState,
  stats: { totalUsers: 0 }
};

const usersReducer = (state = initialState, action) => {
  switch (action.type) {
    /**
     * =======================================================================
     * Get All Users
     * =======================================================================
     */
    case GET_USERS_START:
      return { ...state, getAll: { ...action.payload } };
    case GET_USERS_SUCCESS:
      return { ...state, getAll: { ...action.payload } };
    case GET_USERS_FAILED:
      return { ...state, getAll: { ...action.payload } };
    case GET_USERS_RESET:
      return { ...state, getAll: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Get One User
     * =======================================================================
     */
    case GET_USER_START:
      return { ...state, getOne: { ...action.payload } };
    case GET_USER_SUCCESS:
      return { ...state, getOne: { ...action.payload } };
    case GET_USER_FAILED:
      return { ...state, getOne: { ...action.payload } };
    case GET_USER_RESET:
      return { ...state, getOne: { ...initialLoadingState } };
          
    case 'GET_USER_STATS_SUCCESS':
    return {
        ...state,
        stats: action.payload,
        loading: false
    };
    /**
     * =======================================================================
     * Block One User
     * =======================================================================
     */
    case BLOCK_USER_START:
      return { ...state, blockOne: { ...action.payload } };
    case BLOCK_USER_SUCCESS:
      return { ...state, blockOne: { ...action.payload } };
    case BLOCK_USER_FAILED:
      return { ...state, blockOne: { ...action.payload } };
    case BLOCK_USER_RESET:
      return { ...state, blockOne: { ...initialLoadingState } };
    default:
      return state;
  }
};

export default usersReducer;
